export default __webpack_public_path__ + "static/media/new-2.f37f2372.png";